export enum PaymentMethods {
    CashOnDelivery = 'CASH_ON_DELIVERY',
    CompanyMobileMoney = 'COMPANY_MOBILE_MONEY',
    FlutterWave = 'FLUTTERWAVE',
}
